(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Find all c-banner add-to-cart forms
    const forms = document.querySelectorAll('.c-banner__form');

    forms.forEach((form) => {
      form.addEventListener('submit', async function (e) {
        e.preventDefault();

        const button = form.querySelector('button[type="submit"]');
        const variantId = form.querySelector('input[name="id"]').value;
        const quantity = form.querySelector('input[name="quantity"]')?.value || 1;
        const originalText = button.textContent;

        // Disable button and show loading state
        button.disabled = true;
        button.textContent = 'Adding...';

        try {
          // Add item to cart via AJAX with JSON
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [
                {
                  id: parseInt(variantId, 10),
                  quantity: parseInt(quantity, 10),
                },
              ],
            }),
          });

          if (!response.ok) {
            throw new Error('Failed to add to cart');
          }

          const responseData = await response.json();

          // Dispatch event to open c-sidecart and update cart
          document.dispatchEvent(
            new CustomEvent('cart:item-added', {
              detail: {
                items: responseData.items || [responseData],
                variantId: variantId,
              },
            })
          );

          // Reset button state
          button.textContent = 'Added!';
          setTimeout(() => {
            button.disabled = false;
            button.textContent = originalText;
          }, 1500);
        } catch (error) {
          console.error('Add to cart error:', error);
          button.disabled = false;
          button.textContent = originalText;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const header = document.querySelector('[data-header]');
    const drawer = document.querySelector('[data-drawer]');
    const backdrop = document.querySelector('[data-drawer-backdrop]');

    if (!header || !drawer) return;

    // Desktop Mega Menu - Hover triggers
    const megaTriggers = header.querySelectorAll('[data-mega-trigger]');
    const megaMenus = header.querySelectorAll('[data-mega-menu]');
    let megaTimeout = null;
    let activeMegaMenu = null;

    function showMegaMenu(menuId) {
      clearTimeout(megaTimeout);
      activeMegaMenu = menuId;
      megaMenus.forEach((menu) => {
        menu.classList.toggle('is-active', menu.dataset.megaMenu === menuId);
      });
      megaTriggers.forEach((trigger) => {
        trigger.classList.toggle('is-active', trigger.dataset.megaTrigger === menuId);
      });
      // Reset submenu state when switching menus
      hideSubmenu();
    }

    function hideMegaMenus() {
      megaTimeout = setTimeout(() => {
        activeMegaMenu = null;
        megaMenus.forEach((menu) => menu.classList.remove('is-active'));
        megaTriggers.forEach((trigger) => trigger.classList.remove('is-active'));
        hideSubmenu();
      }, 150);
    }

    // Show mega menu on trigger hover
    megaTriggers.forEach((trigger) => {
      trigger.addEventListener('mouseenter', () => showMegaMenu(trigger.dataset.megaTrigger));
      // Click navigates to the link URL
      trigger.addEventListener('click', () => {
        const url = trigger.dataset.linkUrl;
        if (url) window.location.href = url;
      });
    });

    // Keep mega menu open when hovering the menu itself
    megaMenus.forEach((menu) => {
      menu.addEventListener('mouseenter', () => clearTimeout(megaTimeout));
      menu.addEventListener('mouseleave', hideMegaMenus);
    });

    // Keep mega menu open when hovering the nav bar area
    const navBar = header.querySelector('.c-header__nav');
    if (navBar) {
      navBar.addEventListener('mouseleave', (e) => {
        // Check if we're moving to a mega menu
        const relatedTarget = e.relatedTarget;
        if (relatedTarget && relatedTarget.closest('.c-header__mega-menu')) {
          return;
        }
        // Otherwise close the mega menu
        if (activeMegaMenu) {
          hideMegaMenus();
        }
      });
    }

    // Shop submenu toggle (for collection submenus)
    const submenuTriggers = header.querySelectorAll('[data-submenu-trigger]');
    const submenuContents = header.querySelectorAll('[data-submenu-content]');
    const shopMegas = header.querySelectorAll('[data-shop-mega]');

    function showSubmenu(target) {
      submenuContents.forEach((content) => {
        content.classList.toggle('is-active', content.dataset.submenuContent === target);
      });
      submenuTriggers.forEach((t) => {
        t.classList.toggle('is-active', t.dataset.submenuTrigger === target);
      });
      // Add class to shop mega to show border
      shopMegas.forEach((mega) => {
        mega.classList.toggle('has-active-submenu', target !== null);
      });
    }

    function hideSubmenu() {
      submenuContents.forEach((content) => content.classList.remove('is-active'));
      submenuTriggers.forEach((t) => t.classList.remove('is-active'));
      shopMegas.forEach((mega) => mega.classList.remove('has-active-submenu'));
    }

    submenuTriggers.forEach((trigger) => {
      trigger.addEventListener('mouseenter', () => {
        showSubmenu(trigger.dataset.submenuTrigger);
      });
    });

    // Hide products when hovering back to sidebar only (not when hovering products)
    const megaSidebars = header.querySelectorAll('.c-header__mega-sidebar');
    megaSidebars.forEach((sidebar) => {
      sidebar.addEventListener('mouseleave', (e) => {
        // Only hide if not moving to a submenu trigger or products
        const relatedTarget = e.relatedTarget;
        if (
          relatedTarget &&
          (relatedTarget.closest('[data-submenu-content]') || relatedTarget.closest('[data-submenu-trigger]'))
        ) {
          return;
        }
        // Don't hide immediately - let products panel handle it
      });
    });

    // Keep products visible when hovering them
    submenuContents.forEach((content) => {
      content.addEventListener('mouseenter', () => {
        clearTimeout(megaTimeout);
      });
    });

    // Mobile Drawer
    const drawerToggle = document.querySelector('[data-drawer-toggle]');
    const drawerClose = drawer.querySelectorAll('[data-drawer-close]');
    const drawerViews = drawer.querySelectorAll('[data-drawer-view]');

    function openDrawer() {
      drawer.classList.add('is-open');
      backdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      document.body.style.overflow = '';
      // Reset to main view
      showDrawerView('main');
    }

    function showDrawerView(viewId) {
      drawerViews.forEach((view) => {
        view.classList.toggle('is-active', view.dataset.drawerView === viewId);
      });
    }

    if (drawerToggle) {
      drawerToggle.addEventListener('click', openDrawer);
    }

    drawerClose.forEach((btn) => {
      btn.addEventListener('click', closeDrawer);
    });

    if (backdrop) {
      backdrop.addEventListener('click', closeDrawer);
    }

    // Drawer accordions
    const accordions = drawer.querySelectorAll('[data-drawer-accordion]');
    accordions.forEach((accordion) => {
      accordion.addEventListener('click', () => {
        const group = accordion.closest('[data-drawer-group]');
        if (group) {
          group.classList.toggle('is-open');
        }
      });
    });

    // Mobile products navigation
    const mobileProductLinks = drawer.querySelectorAll('[data-mobile-products]');
    mobileProductLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const view = link.dataset.mobileProducts;
        showDrawerView(view);
      });
    });

    // Back buttons
    const backButtons = drawer.querySelectorAll('[data-drawer-back]');
    backButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        showDrawerView('main');
      });
    });

    // Cart toggle - dispatch event for existing cart functionality
    const cartToggles = document.querySelectorAll('[data-cart-toggle]');
    cartToggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        closeDrawer();
        document.dispatchEvent(new CustomEvent('cart:toggle'));
      });
    });

    // ------------------------------
    // Cart display (mobile badge + desktop count) + bridge to Vue sidecart
    // ------------------------------
    const mobileBadges = () => Array.from(document.querySelectorAll('.c-header__cart-badge'));
    const desktopCounts = () => Array.from(document.querySelectorAll('.c-header__cart-count'));

    function updateCartDisplay(count) {
      // update mobile badges
      mobileBadges().forEach((el) => {
        if (!el) return;
        if (count > 0) {
          el.textContent = count;
          el.style.display = 'inline-block';
          el.setAttribute('aria-hidden', 'false');
        } else {
          el.textContent = '';
          el.style.display = 'none';
          el.setAttribute('aria-hidden', 'true');
        }
      });

      // update desktop counts (shown as `CART (n)`)
      desktopCounts().forEach((el) => {
        if (!el) return;
        if (count > 0) {
          el.textContent = `(${count})`;
          el.style.display = '';
          el.setAttribute('aria-hidden', 'false');
        } else {
          el.textContent = '';
          el.style.display = 'none';
          el.setAttribute('aria-hidden', 'true');
        }
      });
    }

    async function fetchCartCount() {
      try {
        const res = await fetch('/cart.js', { credentials: 'same-origin' });
        if (!res.ok) return updateCartDisplay(0);
        const data = await res.json();
        const count = data && typeof data.item_count === 'number' ? data.item_count : 0;
        updateCartDisplay(count);
      } catch (e) {
        // silent
      }
    }

    // Listen for cart updates dispatched by other sections
    document.addEventListener('cart:updated', () => {
      fetchCartCount();
    });

    // Also listen to a more generic event name used by some integrations
    document.addEventListener('cart:change', () => {
      fetchCartCount();
    });

    // Listen for cart:item-added event (from PDP, collection, upsells, etc.)
    document.addEventListener('cart:item-added', () => {
      fetchCartCount();
    });

    // When c-header dispatches cart:toggle, open the new C Sidecart
    document.addEventListener('cart:toggle', () => {
      // Open the new custom sidecart
      if (window.CSidecart && typeof window.CSidecart.open === 'function') {
        window.CSidecart.open();
      } else {
        // Fallback: dispatch event directly
        document.dispatchEvent(new CustomEvent('c-sidecart:open'));
      }
    });

    // Initial hydrate
    fetchCartCount();

    // Observe the Vue cart-drawer wrapper for open/close/DOM changes and refresh count
    function observeCartDrawer() {
      const wrapper = document.querySelector('#cart-drawer-wrapper');
      if (!wrapper) {
        // try again shortly until the bundle mounts (safe retry)
        setTimeout(observeCartDrawer, 500);
        return;
      }

      const mo = new MutationObserver((mutations) => {
        let changed = false;
        mutations.forEach((m) => {
          if (m.type === 'attributes' || m.type === 'childList') {
            changed = true;
          }
        });
        if (changed) {
          if (window._cHeaderCartDebounce) clearTimeout(window._cHeaderCartDebounce);
          window._cHeaderCartDebounce = setTimeout(() => fetchCartCount(), 120);
        }
      });

      mo.observe(wrapper, { attributes: true, attributeFilter: ['class', 'aria-hidden'], childList: true });
    }

    observeCartDrawer();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.c-hero__hotspot-btn');
    if (!btn) return;

    const url = btn.dataset.productUrl;
    if (!url) return;

    window.location.href = url;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-reviews-swiper"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Initialize Swiper
    const swiperContainers = document.querySelectorAll('[data-reviews-swiper]');

    swiperContainers.forEach((container) => {
      const sectionId = container.dataset.reviewsSwiper;
      const pagination = document.querySelector(`[data-reviews-pagination="${sectionId}"]`);
      const prevBtn = document.querySelector(`[data-reviews-prev="${sectionId}"]`);
      const nextBtn = document.querySelector(`[data-reviews-next="${sectionId}"]`);

      new Swiper(container, {
        slidesPerView: 'auto',
        spaceBetween: 10,
        grabCursor: true,
        pagination: {
          el: pagination,
          clickable: true,
        },
        navigation: {
          prevEl: prevBtn,
          nextEl: nextBtn,
        },
        breakpoints: {
          768: {
            spaceBetween: 20,
          },
        },
      });
    });

    // Video Modal functionality
    const videoTriggers = document.querySelectorAll('[data-video-trigger]');

    videoTriggers.forEach((trigger) => {
      trigger.addEventListener('click', function () {
        const blockId = this.dataset.videoTrigger;
        const modal = document.querySelector(`[data-video-modal="${blockId}"]`);
        if (modal) {
          modal.classList.add('is-active');
          const video = modal.querySelector('video');
          if (video) {
            video.play();
          }
        }
      });
    });

    const modalCloseButtons = document.querySelectorAll('[data-modal-close]');

    modalCloseButtons.forEach((btn) => {
      btn.addEventListener('click', function () {
        const blockId = this.dataset.modalClose;
        const modal = document.querySelector(`[data-video-modal="${blockId}"]`);
        if (modal) {
          modal.classList.remove('is-active');
          const video = modal.querySelector('video');
          if (video) {
            video.pause();
            video.currentTime = 0;
          }
        }
      });
    });

    // Close modal on Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        const activeModal = document.querySelector('.c-review-media__modal.is-active');
        if (activeModal) {
          activeModal.classList.remove('is-active');
          const video = activeModal.querySelector('video');
          if (video) {
            video.pause();
            video.currentTime = 0;
          }
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-tabs"] && !Shopify.designMode) return;
  try {
    
  // Ensure only one tab is open at a time
  document.querySelectorAll('[data-tabs-container]').forEach(container => {
    const items = container.querySelectorAll('[data-tab-item]');

    items.forEach(item => {
      item.addEventListener('toggle', (e) => {
        if (item.open) {
          // Close all other tabs when one is opened
          items.forEach(otherItem => {
            if (otherItem !== item && otherItem.open) {
              otherItem.open = false;
            }
          });
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
